export const getCashoutsRange = ({
    type,
    amount,
    loginBalance,
    sessions,
    roi_rate
}) => {
    // console.log(type, amount, loginBalance, sessions, roi_rate)

    const session_amount = amount + loginBalance;

    let minimal_cashout = parseInt(session_amount * 4);
    if(roi_rate === "MEDIUM") minimal_cashout = parseInt(session_amount * 5);
    if(roi_rate === "HIGH") minimal_cashout = parseInt(session_amount * 6);

    if(!type)
        return {
            minimal_cashout: 50,
            text: '$50'
        }

    if(type === 'cash') {
        const rules = sessions[roi_rate].filter(s => s.type === 'cash').filter(s => s.amounts.from <= session_amount && s.amounts.to >= session_amount)[0] || false;

        if(roi_rate === "LOW" && session_amount < 10) return {
            rules: false,
            text: '-'
        }

        if(roi_rate === "MEDIUM" && session_amount < 15) return {
            rules: false,
            text: '-'
        }

        if(roi_rate === "HIGH" && session_amount < 20) return {
            rules: false,
            text: '-'
        }

        if(!rules)
            return {
                rules,
                text: 'from $50 to $50'
            };

        if(minimal_cashout < 50)
            return {
                rules,
                text: `from $50 to $${rules.maximal_cashout}`
            };

        return {
            rules,
            text: `from $${Math.floor(minimal_cashout)} to $${rules.maximal_cashout}`
        };
    } else if(type === 'testyourluck') {
        const rules = sessions[roi_rate].filter(s => s.type === 'testyourluck')[0] || false;

        if(!rules)
            return {
                rules,
                text: 'N/A'
            };

        if(rules.cashout === rules.minimal_cashout)
            return {
                rules,
                text: `$${rules.cashout}`
            };

        return {
            rules,
            text: `$${rules.cashout} when you reach $${rules.minimal_cashout}`
        };
    } else if(type === 'freeplay') {
        const rules = sessions[roi_rate].filter(s => s.type === 'freeplay')[0] || false;

        if(!rules)
            return {
                rules,
                text: 'N/A'
            };

        if(rules.cashout === rules.minimal_cashout)
            return {
                rules,
                text: `$${rules.cashout}`
            };

        return {
            rules,
            text: `$${rules.cashout} when you reach $${rules.minimal_cashout}`
        };
    }

    return {
        rules: null,
        text: 'N/F'
    }
}

